import { useEffect, useState } from 'react'
import { fetchStudentsToBeDeleted } from 'services/StudentsService'
import styled from 'styled-components'
import Table from 'components/Table'
import StudentsTableRow from 'modules/students/components/StudentsTableRow'
import ExpandablePanel from 'components/ExpandablePanel'

const StudentsToDelete = () => {
  const [students, setStudents] = useState([])

  const fetchStudents = () => {
    fetchStudentsToBeDeleted()
      .then(students => {
        setStudents(students.filter(student => !student.removed))
      })
  }

  useEffect(() => {
    fetchStudents()
  }, [])

  return (
    <div>
      <PageHeader>
        Uczniowie do usunięcia
      </PageHeader>
      <ExpandablePanel startOpen title='Lista uczniów'>
      <Table>
        <thead>
        <tr>
          <th>Lp.</th>
          <th>Nazwa</th>
          <th>Typ lekcji</th>
          <th>Przedmiot</th>
          <th>Nauczyciel</th>
          <th>Czas</th>
          <th>Stawka ucz.</th>
          <th>Stawka nau.</th>
          <th>Email</th>
          <th>Tel.</th>
          <th />
        </tr>
        </thead>
        <tbody>
        {students.map((student, index) => (
          <StudentsTableRow
            isTeacherView={false}
            isDebtorsView={true}
            order={index + 1}
            student={student}
            key={`student-${student.id}`}
            actionCallback={fetchStudents}
          />
        ))}
        </tbody>
      </Table>
      </ExpandablePanel>
      
    </div>
  )
}

export default StudentsToDelete

const PageHeader = styled.div`
  font-size: 24px;
  margin-bottom: 20px;
`
